import { Component, OnInit,ElementRef  } from '@angular/core';
import { DataDBService } from '../servicios/data-db.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { PeticionesService } from '../servicios/httpservice';
import { LocalStorageService } from 'ngx-webstorage';

import { PartnercteService } from '../servicios/partnercte.service';
@Component({
  selector: 'app-partner-descuentos',
  templateUrl: './partner-descuentos.component.html',
  styleUrls: ['./partner-descuentos.component.css']
})
export class PartnerDescuentosComponent implements OnInit {
  public arrayAccesos:any=[];
  public DatosUsuario:any;
  public tagName:any;
  currentIndex = 0;
  visibleItems = 4;
  public arrayAplicaLineas:any = [];
  public arrayMontominimo:any = [];
  public arrayOfertasTiempoLimitado:any = [];
  public strConexion:string ='';
  public arrayDescuentos:any = [];
  constructor(public localSt: LocalStorageService,private indexedDBService: DataDBService,private _httpService: PeticionesService, private router: Router,
      elem: ElementRef) {
    this.tagName = elem.nativeElement.tagName.toLowerCase();


    let arrayDatos = []
    arrayDatos = JSON.parse(localStorage.getItem('ngx-webstorage|arrayaccesos'))
    if(arrayDatos && arrayDatos.length > 0){
      this.indexedDBService.getItem('arrayResult', (value) => {
        this.arrayAccesos=value?value:[];
         this.DatosUsuario = this.arrayAccesos[0]
       if (this.arrayAccesos.length > 0) {
         this.DatosUsuario = this.arrayAccesos[0]
         this._httpService.setMostrarMenu(true);
         this.strConexion = this.localSt.retrieve('strConexion');
         this.fnGetDescuentos()
        // this.DatosUsuario.strUsuario = "lgomez"
        }else{
          this.router.navigate(['/login']);
        }
       }); 
    }else{
      this.strConexion = 'COMERCIAL'
      this.fnGetDescuentos()
    }
   /*  */
   }

  ngOnInit(): void {
    this.setResponsiveItems();
    window.addEventListener('resize', () => this.setResponsiveItems());
  }



  setResponsiveItems() {
    const width = window.innerWidth;
 
    if (width < 768) {
      this.visibleItems = 2;
    } else if (width < 992) {
      this.visibleItems = 3;
    } else {
      this.visibleItems = 4;
    }
  }
  
  getTransform(): string {
    return `translateX(-${this.currentIndex * (100 / this.visibleItems)}%)`;
  }
  
  nextSlide() {
    if (this.currentIndex < this.arrayOfertasTiempoLimitado.length - this.visibleItems) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0;
    }
  }
  
  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.arrayOfertasTiempoLimitado.length - this.visibleItems;
    }
  }

  fnGetDescuentos(){
        let objSend = {
          strConexion:this.strConexion,
          strAccion:"GETPAGINA_DESCUENTOS"
        }
        this._httpService.mostrarCotizaciones(objSend, 'sp_PartNer').subscribe(
          result => {
            
            this.arrayDescuentos = result;
            this.arrayDescuentos.forEach(desc => {
              desc.strMensaje = desc.strMensaje!= null &&  desc.strMensaje!= undefined &&  desc.strMensaje!= ""?desc.strMensaje:"assets/detoportunidad/noDisponible.jpg"
            });
            this.fnSepararDesc(this.arrayDescuentos);
          },error => {
            Swal.fire("Error!",error.message,"success")
          }
        )
  }

  fnSepararDesc(arrayT:any){
    this.arrayAplicaLineas = []
    this.arrayMontominimo = []
    this.arrayOfertasTiempoLimitado = []

    arrayT.forEach(o => {
      if((o.strAplicaLinea != null &&  o.strAplicaLinea != undefined &&  o.strAplicaLinea != "") || ( o.dblCantidadMinimaProducto != null &&  o.dblCantidadMinimaProducto != undefined &&  o.dblCantidadMinimaProducto != "")){
        this.arrayAplicaLineas.push(o)
      } else if((o.dblMontoMinimoOrden != null &&  o.dblMontoMinimoOrden != undefined &&  o.dblMontoMinimoOrden != "") || (o.intPrimerCompra != null &&  o.intPrimerCompra != undefined &&  o.intPrimerCompra != "")){
        this.arrayMontominimo.push(o)
      }else if( o.strArticulo != null &&  o.strArticulo != undefined &&  o.strArticulo != ""){
        this.arrayOfertasTiempoLimitado.push(o)
      }
    });





  }

  addToCart(obj:any){

    if (this.arrayAccesos.length > 0) {
      localStorage.setItem('strArticulo_Seleccionado_Cotizador', JSON.stringify(obj));
      this.localSt.clear('strArticulo_Seleccionado_Comodato' );
      this.router.navigate(['/detalle_articulo']);
     }
     else {
      this.router.navigate(['/login']);
     }
    

    
  }
  
  fnIrDescuentosLineas(item:any){
    sessionStorage.setItem('datosCompletos', JSON.stringify(item));

    if(item.strAplicaLinea && item.strAplicaLinea != ""){
      this.router.navigate(['/partner-detalle-descuentos']);
    }else{
      this.router.navigate(['/partner-detalle-descuentos']);
    }
  }

  fnIrCompras(){
    this.router.navigate(['/cotizador_Linea']);
  }

  onImgError(event: any) {
    event.target.src = 'assets/detoportunidad/noDisponible.jpg';
  }

  
}


